import React from 'react';
import UsageMaintenanceMatchingWorksToolbar from './UsageMaintenanceMatchingLicenseToolbar';
import { initial, set } from 'lodash';
import SearchViewKeyEventListener from '../../../../components/searchView/SearchViewKeyEventListener';
import CustomButton from '../../../../components/usageComponents/customButton/CustomButton';
import { IRepertoireField } from '../../../../types/IRepertoireField';
import { USAGE_GROUP_MATCHING_LICENSE_KEY, USAGE_LICENSE_MATCHING, USAGE_MATCHING_LICENSE_SEARCH_FIELDS_KEY, USAGE_MATCHING_WORKS_SECTION_KEY } from '../../../../Consts';
import { SizedTextDataInput } from '../../../../components/usageComponents/textInput/TextInput';
import { IRepertoireStateKeys } from '../../../../types/IRepertoireStateKeys';
import SelectionTable from '../../../../components/usageComponents/selectionTable/SelectionTable';
import { SizedDropdownDataInput } from '../../../../components/dropdownDataInput/DropdownDataInput';
import { getLookupValues } from '../../../../../home/helpers/UsageJobFormFieldsHelper';
import SizedDateDataInput from "../../../../components/dateDataInput/DateDataInput";
import DataGridTable from '../../../../components/dataGridTable/DataGridTable';
import { ITableAction } from '../../../../types/ITableAction';
import IRepertoireComponentDataItem from '../../../../../redux/types/IRepertoireComponentDataItem';
import { hideModal } from '../../../../../redux/reducers/ModalReducer';
import { addMatchLicenseToUsage, updateUsageField } from '../../../../../redux/reducers/RepertoireReducer';
import { ILicenseUsageSearchQuery } from '../../../../types/usageTypes/ILicenseUsageSearchQuery';
import { IUsageGroupState } from '../../../../../redux/types/IUsageGroupState';
import { ILicenseUsage } from '../../../../types/usageTypes/ILicenseUsage';

const initialSearchFieldsData = {
    customerId: '',
    customerName: '',
    venueReference: '',
    venueName: '',
    artist: '',
    startDate: '',
    endDate: '',
};

export interface IUsageMaintenanceGridMatchingLicenseViewProps {
    searchViewData: IRepertoireComponentDataItem;
    isLoading: boolean,
    searchLicenseResultsTableData: IRepertoireComponentDataItem,
    searchSuccessful?: boolean;
    expandAll?: boolean;
    updatePagination?: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sortSearchResults: any,
    hideModal: typeof hideModal;
    modalProps: any,
    addMatchLicenseToUsage?: typeof addMatchLicenseToUsage;
    searchLicenses: (query: ILicenseUsageSearchQuery) => void;
    licensesSearchResults: any,
    usageGroup: IUsageGroupState,
    usageDataGridTableData: IRepertoireComponentDataItem,
    updateUsageField: typeof updateUsageField,
}

const DEFINITE_MATCH = 'Definite Match';
const POTENTIAL_MATCH = 'Potential Match';

const UsageMaintenanceGridMatchingLicenseView: React.FC<IUsageMaintenanceGridMatchingLicenseViewProps> = ({
    searchViewData,
    isLoading,
    searchSuccessful,
    searchLicenseResultsTableData,
    updatePagination,
    sortSearchResults,

    hideModal,
    modalProps,
    addMatchLicenseToUsage,
    searchLicenses,
    licensesSearchResults,
    usageGroup,
    usageDataGridTableData,
    updateUsageField,

}) => {
    const [showSearchFields, setShowSearchFields] = React.useState(false);
    const [searchFieldsData, setSearchFieldsData] = React.useState(initialSearchFieldsData);

    const handleShowSearchFieldsAndResults = () => {
        setShowSearchFields(!showSearchFields);
    }

    const changeData = (value: string | boolean, fieldName: IRepertoireStateKeys, isOnBlur?: boolean) => {
        const newData = { ...searchFieldsData };
        newData[fieldName] = value;
        setSearchFieldsData(newData);
    }

    const keyDownSubmit = (e: any) => {
    }

    const handleDateChange = (date: string | boolean, fieldName: IRepertoireStateKeys, index?: number) => {
        const newData = { ...searchFieldsData };
        newData[fieldName] = date;
        setSearchFieldsData(newData);
    }

    const clearModalSearchResults = () => {}

    const renderSearchFields = () => {
     let filteredSearchFields = searchViewData.fields.filter(
                (searchField: IRepertoireField) =>
                    searchField.componentInstance === USAGE_LICENSE_MATCHING
            );

       return filteredSearchFields.map((searchField: IRepertoireField) => {

        if (searchField.fieldType === 'text' || searchField.fieldType === 'integer') {
            return (   <SizedTextDataInput
                                            fieldType={searchField.fieldType}
                                            useEnterSubmit={true}
                                            label={searchField.data}
                                            fieldName={searchField.name}
                                            changeData={changeData}
                                            handleKeyDown={keyDownSubmit}
                                            value={searchFieldsData[searchField.name]}
                                            readOnly={false}
                                            isHidden={searchField.hidden}
                                        />)
        }

        if (searchField.fieldType === 'date') {
                                    return <div>
                                                <SizedDateDataInput
                                                                       label={searchField.data}
                                                                       fieldName={searchField.name}
                                                                        changeData={handleDateChange}
                                                                        value={searchFieldsData[searchField.name]}
                                                                        readOnly={false}
                                                                        isHidden={false}
                                                                    />
                                    </div>
        }
    })


    }

    const onClickSearch = () => {
        const query = {
            id: '',
            customerID: searchFieldsData.customerId,
            venueReference: searchFieldsData.venueReference,
            customerName: searchFieldsData.customerName,
            artist: searchFieldsData.artist,
            dateFrom: searchFieldsData.startDate,
            dateTo: searchFieldsData.endDate,
            artistName: searchFieldsData.artist,
            venueName: searchFieldsData.venueName,
        } as ILicenseUsageSearchQuery;

        searchLicenses(query)
    }

    const handleAddLicense = (newLicense: ILicenseUsage) => {
        newLicense.status = DEFINITE_MATCH;
        let newData = usageGroup.matchingLicenses ? usageGroup.matchingLicenses : [];
        const isDuplicate = newData.some(license => license.id === newLicense.id);

        if (!isDuplicate) {
        newData.push(newLicense);
        }

   

        if(newData.length > 1){
            newData = newData.map((license) => {
                license.status = POTENTIAL_MATCH;
                return license;
            })
        }
        updateUsageField(newData, 'matchingLicenses' as IRepertoireStateKeys);
    }

    const handleMakeDefiniteClick = (row: any) => {
        let newData = usageGroup.matchingLicenses;
        newData = newData.filter((license) => { return license.id === row.id });
        newData = newData.map((license) => {
            if (license.id === row.id) {
                license.status = DEFINITE_MATCH;
            } else {
                license.status = '';
            }
            return license;
        })

        updateUsageField(newData, 'matchingLicenses' as IRepertoireStateKeys);
    }

    const changeDataSecondTable = (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => {
        if(value.length === 1) {
            value[0].status = DEFINITE_MATCH;	
        }
        updateUsageField(value, 'matchingLicenses' as IRepertoireStateKeys);
        
     }

    const getTableActions = () => {
        let actions: ITableAction[] = [];
        return actions;
    } 

    const showModal = () => {}

    const renderSearchResults = () => {
            if (isLoading) {
                return (<div className="loaderWrapper">
                    <div className="spinner-dualball">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>)
            }
    
            if (searchSuccessful &&
                    ((!!licensesSearchResults && licensesSearchResults.length <= 0))) {
                    return (
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                                No results found.
                            </div>
                        </div>
                    )
                }
                else if (licensesSearchResults && licensesSearchResults.length >= 1) {

                    return (<div className="row">
                        <SelectionTable
                            key={'selection table'}
                            searchResultsTableData={searchLicenseResultsTableData}
                            tableContents={licensesSearchResults}
                            componentInstance={"usagesLicenseMatchingSearchResults"}
                            sourceItem={modalProps}
                            hideModal={hideModal}
                            updatePagination={updatePagination}
                            repertoireSection={USAGE_MATCHING_LICENSE_SEARCH_FIELDS_KEY}
                            addMatchLicenseToUsage={handleAddLicense}
                            sortSearchResults={sortSearchResults}
                        />
                    </div>)
                }
                else if (searchSuccessful == false) {
                    return (
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                                Error while searching, please contact customer support if issue persists.
                            </div>
                        </div>
                    )
                }
            }
    

    return (
        <div id={`usage-matching-license-${USAGE_GROUP_MATCHING_LICENSE_KEY}`}>

            <UsageMaintenanceMatchingWorksToolbar
                handleShowSearchFieldsAndResults={handleShowSearchFieldsAndResults}
                isShowSearchFieldsAndResults={showSearchFields}
            />
            <div className="row">
                {showSearchFields && <div className="marginMedium">
                    <div className="searchView">
                        <div className="row">
                            {renderSearchFields()}
                        </div>
                        <div className="row">
                            <div className="form-group col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-6 col-sm-push-6 col-xs-12 col-xs-push-0">
                                <CustomButton buttonText="Search" buttonAction={() => onClickSearch()} disabled={false} />
                            </div>
                        </div>
                        <div>
                            {renderSearchResults()}
                        </div>
                    </div>
                </div>}
                <div className="matchingWorksSection marginVeryLarge" >
                    <DataGridTable
                        dataGridTableData={usageDataGridTableData}
                        componentInstance={USAGE_LICENSE_MATCHING}
                        tableContents={usageGroup.matchingLicenses}
                        tableActions={getTableActions()}
                        showModal={showModal}
                        clearModalSearchResults={clearModalSearchResults}
                        stateKey={USAGE_LICENSE_MATCHING}
                        hideModal={hideModal}
                        changeData={changeDataSecondTable}
                        showRowNumber={false}
                        sortData={undefined}
                        clearAllRowsButThis={handleMakeDefiniteClick}
                    />
                </div>
            </div>
        </div>
    )

}

export default UsageMaintenanceGridMatchingLicenseView;